import { OAuthData } from '../types';

export const getOAuthDataFromURL = (): OAuthData => {
  const url = new URL(window.location.href);

  return {
    code: url.searchParams.get('code'),
    error: url.searchParams.get('error') as OAuthData['error'],
    provider: url.searchParams.get('provider') as OAuthData['provider'],
    state: url.searchParams.get('state'),
  };
};
